import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { Directory, Encoding, Filesystem, } from "@capacitor/filesystem";
import { getSecureStorageToken } from "core/apollo/SecureStoragePluginFunctions";
export const DownloadLink = (params) => {
    const platform = Capacitor.getPlatform();
    const downloadFile = async () => {
        const token = await getSecureStorageToken();
        const options = {
            url: `${window.argonBaseUrl}${params.href}`,
            headers: {
                authorization: token ? `Bearer ${token.value}` : "",
            },
        };
        const response = await CapacitorHttp.request(options);
        console.log(response);
        const fileNameMatch = response.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        let fileName = "download";
        if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, "");
        }
        const writeFileOptions = {
            path: fileName,
            directory: Directory.Documents,
            data: response.data,
            encoding: Encoding.UTF8,
        };
        try {
            await Filesystem.writeFile(writeFileOptions);
            console.log("File written");
        }
        catch (error) {
            console.error("Failed to write file:", error);
        }
    };
    if (platform === "web") {
        return (_jsx(Link, { href: params.href, download: true, component: "a", children: _jsx(DownloadIcon, {}) }));
    }
    else {
        return (_jsx(Link, { component: "button", onClick: () => downloadFile(), style: { cursor: "pointer", color: "inherit" }, children: _jsx(DownloadIcon, {}) }));
    }
};
